import styled from 'styled-components'

export const Content = styled.p`
  ${({ font }) => font && `font-family: ${font};`}
  ${({ color }) => color && `color: ${color};`}
  font-size: 20px;
  line-height: 26px;
  min-height: 26px;
`
